export default "__VITE_ASSET__lBLBTj7E__"